const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  config: state => state.app.config,
  provinceList: state => state.app.provinceList,
  navigation: state => state.app.navigation,
  footer_navigation: state => state.app.footer_navigation,
  help_center: state => state.app.help_center,
  categoryList: state => state.app.categoryList,
  seo_list: state => state.app.seo_list,
  token: state => state.user.token,
  username: state => state.user.username,
  phone: state => state.user.phone,
  avatar: state => state.user.avatar,
  company: state => state.user.company,
  user_group: state => state.user.user_group,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js